// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-access-list-direct-accesses-table__filters {
  margin-bottom: 8px;
}
.dl-iam-access-dialog-access-list-direct-accesses-table__table table {
  width: 100%;
}
.dl-iam-access-dialog-access-list-direct-accesses-table__empty {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AccessList/DirectAccessesTable/DirectAccessesTable.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAIQ;EACI,WAAA;AAFZ;AAMI;EACI,kBAAA;AAJR","sourcesContent":[".dl-iam-access-dialog-access-list-direct-accesses-table__filters {\n  margin-bottom: 8px;\n}\n.dl-iam-access-dialog-access-list-direct-accesses-table__table table {\n  width: 100%;\n}\n.dl-iam-access-dialog-access-list-direct-accesses-table__empty {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
